var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M4 10h4m10 0h4M4 11h4m10 0h4M2 12h2m4 0h2m6 0h2m4 0h2M2 13h2m4 0h2m6 0h2m4 0h2M2 14h2m4 0h2m6 0h2m4 0h2M2 15h2m4 0h2m6 0h2m4 0h2M4 16h4m10 0h4M4 17h4m10 0h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#edff93",
    d: "M4 12h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4cff00",
    d: "M6 12h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    d: "M10 12h4m-4 1h4m-4 1h4m-4 1h4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffeb93",
    d: "M18 12h2m-2 1h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff7f00",
    d: "M20 12h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d9946",
    d: "M6 14h2m-2 1h2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c96240",
    d: "M20 14h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.10c19b932ea25b4d29d65bb624b6b689.svg";
export { ForwardRef as ReactComponent };